export const actionTypes = Object.freeze({
  USER_LOGGED_IN: 'user_logged_in',
  USER_LOGGED_OUT: 'user_logged_out'
});
